import { onPageLoad } from '../modules/page_lifecycle.js';
import { fadeOutElement, hideElement, qs, qsa } from '../modules/dom.js';
import { onModalEvent, showModal } from '../modules/bootstrap_ui.js';

function fixIntroVideoSize() {
  const video = qs('#intro-bg');
  if (!video) return;

  const introBlock = qs('#intro-block');
  if (!introBlock) return;

  const height = video.getBoundingClientRect().height;
  const topPadding = `${Math.floor(height / 2) - 50}px`;

  introBlock.style.height = `${height}px`;
  introBlock.style.paddingTop = topPadding;

  if (video.readyState !== 4) {
    window.setTimeout(fixIntroVideoSize, 500);
  }
}

onPageLoad(fixIntroVideoSize);
window.addEventListener('resize', fixIntroVideoSize);

onPageLoad(() => {
  qsa('.intro-block-video').forEach((video) => {
    video.addEventListener('play', () => {
      const overlay = video.closest('.intro-block')?.querySelector('.video-overlay');
      fadeOutElement(overlay);
    });
  });

  qsa('.play-button').forEach((button) => {
    button.addEventListener('click', () => {
      qs('.intro-block-video')?.play();
    });
  });

  qsa('.play-webinar-button').forEach((button) => {
    button.addEventListener('click', (event) => {
      const id = event.currentTarget.id;
      const videoDiv = qs(`#webinar-video-${id}`);
      videoDiv?.querySelector('video')?.play();
      fadeOutElement(videoDiv?.parentElement?.querySelector('.video-overlay'));
    });
  });

  qsa('.webinar-video').forEach((video) => {
    video.addEventListener('play', () => {
      fadeOutElement(video.parentElement?.parentElement?.querySelector('.video-overlay'));
    });
  });

  const modal = qs('#requestCallbackModal');
  if (modal) {
    hideElement(qs('.submit-btn-group', modal));
    qs('#requestCallbackModalSubmitButton', modal)?.addEventListener('click', () => {
      qs('form', modal)?.requestSubmit();
    });
    onModalEvent('requestCallbackModal', 'show.bs.modal', () => {
      qs('input:not([type="hidden"])', modal)?.focus();
    });
  }

  qs('#menuCalendlyLink')?.addEventListener('click', (event) => {
    event.preventDefault();
    Calendly.initPopupWidget({ url: 'https://calendly.com/gwisales' });
  });
});
